<template>
  <v-flex>
    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario :modelReserva="this.modelReserva" :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos" @cerrar="dialogFormularioReserva = false" />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la reserva?
            </v-label>
          </v-row>

          <v-row class="mt-8 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarReserva()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">PRESUPUESTOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-chip class="ml-4" @click="mostrarbusqueda = !mostrarbusqueda" :color="colorEBikeAccent1">
          <v-avatar left>
            <v-icon>mdi-eye</v-icon>
          </v-avatar>
          <h5>BUSQUEDA</h5>
        </v-chip>
        <v-spacer></v-spacer>

        <!--
        <v-chip class="mr-4" :color="colorAccent1" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip>

        -->

        <v-chip class="mr-1" link :color="colorEBikeAccent1" @click="_crearReserva()">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-tag-plus</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">NUEVA RESERVA</h5>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <!--  <v-col cols="2" align="start">
            <v-radio-group
              :dark="dark"
              v-model="busquedaFechas"
              :mandatory="false"
            >
              <v-radio
                class="mb-4"
                color="green"
                label="Reservas activas"
                value="activas"
              ></v-radio>
                 <v-radio
                class="mb-4"
                color="green"
                label="De Hoy"
                value="hoy"
              ></v-radio> 
              <v-radio color="green" label="Todas" value="todas"></v-radio>
            </v-radio-group>
          </v-col>
          -->

          <v-col class="mr-8" cols="3" align="start">
            <v-menu :dark="dark" v-model="date1" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaDesde" label="Desde"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaDesde" @input="date1 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>

            <v-menu :dark="dark" v-model="date2" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaHasta" label="Hasta"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaHasta" @input="date2 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3" align="start">
            <v-text-field :dark="dark" clearable outlined v-model="busquedaCliente" autocomplete="off"
              label="Busqueda por cliente" placeholder="Nombre, Teléfono, email..." @keyup.enter="_getReservas"
              dense></v-text-field>

              <v-text-field
              :dark="dark"
              clearable
              outlined
              v-model="busquedaPresupuesto"
              autocomplete="off"
              label="Busqueda Presupuesto"
              placeholder="Busqueda por código de presupuesto"
              @keyup.enter="_getReservas"
              dense
            ></v-text-field>
          </v-col>

          <!--  <v-col>
            <v-chip class="mr-1" color="primary" @click="_limpiarfiltros">
              <v-avatar left>
                <v-icon size="20">mdi-filter-remove</v-icon>
              </v-avatar>
            </v-chip>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col>
          <v-progress-linear class="mt-12 mb-12" :color="colorEBikeAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row justify="end">
          <v-switch class="mr-6 mb-2" v-model="checkSoloAccion" inset
            :label="'Mostrar solo Recogidas'"></v-switch>
        </v-row>
        <v-row v-if="reservasFiltradas" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table locale="es" v-if="reservasFiltradas" dense light :headers="headersLargo"
              :items="reservasFiltradas" :items-per-page="reservasFiltradas.length" hide-default-footer
              :group-by="['fecha']" class="elevation-1">
              <template v-slot:group="{ items }">
                <tr v-bind:style="{ background: 'rgb(200, 200, 200)' }" @click="toggle(items[0].fecha_inicial)">
                  <td colspan="10" align="left">
                    <strong style="color: black">{{
                      _captionFecha(items[0].fecha, true)
                    }}</strong>
                  </td>
                </tr>

                <tr class="mb-2" v-for="item in items" :key="item.fecha + item.id" v-show="!item.hide">
                  
                  <td width="150px" align="left" v-bind:style="{ 'white-space':'nowrap', 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{
                      item["cod_presupuesto"]
                    }}
                  </td>
                  
                  
                  <td width="150px" align="center"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{
                      item["fecha_bloqueo"] == item["fecha"]
                        ? item["cant_bicis"]
                        : ""
                    }}

                    <br />
                    {{
                      item["fecha_bloqueo"] == item["fecha"]
                        ? _captionBicisNumero(item)
                        : ""
                    }}

                  </td>

                  <td width="150px" align="center"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{
                      item["fecha_final"] == item["fecha"]
                        ? item["cant_bicis"]
                        : ""
                    }}
                    <br />
                    {{
                      item["fecha_final"] == item["fecha"]
                        ? _captionBicisNumero(item)
                        : ""
                    }}
                  </td>

                  <td width="1%" align="left"
                    v-bind:style="{ 'white-space': 'nowrap', 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{
                      item["fecha_bloqueo"] == item["fecha"]
                        ? (item["ubicacion_inicial"] != null ? item["ubicacion_inicial"] : "")
                        : (item["ubicacion_final"] != null ? item["ubicacion_final"] : "")
                    }}
                  </td>

                  <td align="left"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{ item["cliente"]["nombre"] }}
                    <br />
                    <span v-bind:style="{ color: 'rgb(150, 150, 150)' }">
                      {{ item["cliente"]["telefono"] }}
                    </span>
                  </td>



                  <td width="100px" align="center"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">
                    {{ item["cant_dias"] }}
                  </td>

                  <!--
                  <td width="100px" align="right"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">{{
                    item["pagado"] }}</td>
                  <td width="100px" align="right"
                    v-bind:style="{ 'border-right': '1px solid', 'border-right-color': 'rgb(220, 220, 220)' }">{{
                      item["pendiente"] }}</td>

                   -->   

                  <td width="170px" align="right">
                    <v-chip class="mr-1" label small :color="colorAccent2" text-color="white" link
                      @click="_editar(item)">
                      Editar
                    </v-chip>

                    <v-chip label small color="red lighten-2" text-color="white" link @click="_delete(item)">
                      Eliminar
                    </v-chip>
                  </td>
                </tr>
              </template>

              <template v-slot:no-data>
                <v-row class="mt-1 ml-4" justify="start" dense></v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReservaFormulario from "../components/formularios/ReservaFormulario.vue";

export default {
  components: {
    ReservaFormulario,
  },

  data: () => ({
    dialogFormularioReserva: false,
    dialogReservaUpdate: false,
    accion: "",

    checkSoloAccion: false,

    mostrarbusqueda: false,
    date1: false,
    date2: false,

    busquedaDesde: new Date().toISOString().substr(0, 10),
    busquedaHasta: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
    fechaEntre: [new Date().toISOString().substr(0, 10), new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)],


    busquedaCliente: "",
    busquedaAgencia: null,
    busquedaPresupuesto: null,

    modelReserva: null,
    editando: false,

    showConfirmacionEliminacion: false,

    headersLargo: [
      { text: "PRESUPUESTO", align: "center", sortable: false, value: "cod_presupuesto" },
      {
        text: "FECHA",
        align: "center",
        sortable: false,
        value: "fecha",
      },
      {
        text: "ENTREGAR",
        align: "center",
        sortable: false,
        value: "fecha_bloqueo",
      },
      {
        text: "RECOGER",
        align: "center",
        sortable: false,
        value: "fecha_final",
      },
      {
        text: "LUGAR",
        align: "left",
        sortable: false,
        value: "ubicacion_inicial",
      },
      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        value: "cliente.nombre",
      },

      { text: "DIAS", align: "center", sortable: false, value: "cant_dias" },

      /*{ text: "PAGADO", align: "right", sortable: false, value: "pagado" },
      {
        text: "PENDIENTE",
        align: "right",
        sortable: false,
        value: "pendiente",
      },*/

      { text: "ACCIONES", value: "action", sortable: false, align: "center" },
      // { text: "", value: "action", sortable: false, align: "end" },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",
      "colorEBikeAccent1",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("estados", ["estados"]),
    ...mapState("reservas", ["reservas", "dialogWidth", "reservaSelec"]),

    reservasFiltradas() {
      const reservasPresupuesto = this.reservas.filter((r) =>
        this._esEstadoPresupuesto(r.estado)
      );

      if (this.checkSoloAccion) {
        return reservasPresupuesto.filter(
          (r) => r.accion == "RECOGIDA"
        );
      } else {
        return reservasPresupuesto.filter(
          (r) => r.accion == "ENTREGA" || r.accion == "RECOGIDA"
        );
      }
      
    },
  },

  watch: {


    busquedaDesde(value) {
      if (value != null && this.busquedaHasta != null) {
        this.fechaEntre[0] = value;
        this.fechaEntre[1] = this.busquedaHasta;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },

    busquedaHasta(value) {
      if (value != null && this.busquedaDesde != null) {
        this.fechaEntre[0] = this.busquedaDesde;
        this.fechaEntre[1] = value;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },
  },

  mounted() {
    this._getReservas(true);
  },

  methods: {
    ...mapActions("reservas", ["getReservas", "eliminarReserva"]),

    ...mapMutations("reservas", [
      "setDialogWidth",
      "setRutaSelec",
      "setFechaSelec",
      "setReservaSelec",
    ]),
    ...mapMutations("infoDiario", ["setDiarioFechaSelec"]),

    _captionBicisNumero(item) {
      let res = "[";
      for (let index = 0; index < item.bicis.length; index++) {
        res = res + item.bicis[index].talla + item.bicis[index].numero.toString() + ', ';
      }
      return res.slice(0, -2) + "]";
    },

    _getColorAccion(item) {
      if (item.accion == "ENTREGA" || item.accion == "RECOGIDA") {
        return item.estado.color;
      }
      return "#FFFFFF";
    },

    _getColorEstado(reserva) {
      return reserva.estado.color;
    },

    _goToPanelDiario(item) {
      this.setDiarioFechaSelec(item.fecha);
      this.$router.push({ path: "/Diario" });
    },

    _delete(item) {
      this.setReservaSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    async _eliminarReserva() {
      this.showConfirmacionEliminacion = false;
      if (this.reservaSelec != null) {
        await this.eliminarReserva([
          this.access_token,
          this.reservaSelec.id.toString(),
        ]);

        this._getReservas(true);
      }
    },

    _captionPax(item) {
      let cantSentados = 0;
      for (let index = 0; index < item.viaje_reservas.length; index++) {
        cantSentados = cantSentados + item.viaje_reservas[index].asientos;
      }
      if (cantSentados == 0 || item.pax == cantSentados) {
        return item.pax;
      }
      return cantSentados.toString() + "/" + item.pax.toString();
    },

    _getColorSentadosoNo(item) {
      return "black";
      /*  let cantSentados = 0;
      for (let index = 0; index < item.viaje_reservas.length; index++) {
        cantSentados = cantSentados + item.viaje_reservas[index].asientos;
      }
      if (item.pax > cantSentados){
        return "orange";
      }else{
        return "green";
      } */
    },

    _imprimir() { },

    _captionFecha(fecha, con_diasemana) {
      if (fecha) {
        return (
          (con_diasemana ? this._diasemana(fecha) + " " : "") +
          fecha.substring(8, 10) +
          "-" +
          fecha.substring(5, 7) +
          "-" +
          fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = ["LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO", "DOMINGO"];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservas(false);
    },

    _crearReserva() {
      this._inicializarModelReserva();
      this.accion = "crear";
      this.dialogFormularioReserva = true;
    },

    _editar(item) {
      this.setReservaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.reservaSelec));
      this.modelReserva = temp;
      this.accion = "editar";
      this.dialogFormularioReserva = true;
    },

    _esEstadoPresupuesto(estado) {
      const estadoId = Number(estado && estado.id);
      return estadoId == 1 || estadoId == 3;
    },

    async _getReservas(showload) {
      const params = {};
      if (this.fechaEntre[0] && this.fechaEntre[1]) {
        params.fechaEntre = this.fechaEntre;
      }

      if (this.busquedaCliente && this.busquedaCliente != "") {
        params.cliente = this.busquedaCliente;
      }

      if (this.busquedaPresupuesto && this.busquedaPresupuesto != "") {
        params.presupuesto = this.busquedaPresupuesto;
      }

      await this.getReservas([this.access_token, params, showload]);

    },

    _limpiarfiltros() {
      this.busquedaDesde = null;
      this.busquedaHasta = null;
      this.busquedaCliente = "";
      this._getReservas(true);
    },

    toggle(fecha) {
      this.reservas.forEach((reserva) => {
        if (reserva.fecha === fecha) {
          reserva.hide = !reserva.hide;
        }
      });
    },

    _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        fecha_inicial: null,
        fecha_bloqueo: null,
        fecha_final: null,
        ubicacion_inicial: null,
        ubicacion_final: null,

        cant_dias: 0,
        cant_bicis: 0,
        cant_bicis_s: 0,
        cant_bicis_m: 0,
        cant_bicis_l: 0,
        cant_bicis_xl: 0,

        precio: 0.00,
        importe: 0.00,
        fianza: 0.00,
        descuento: 0.00,
        total: 0.00,

        pagado: 0.00,
        pendiente: 0.00,

        transporte_km: 0,
        transporte_precio: 0.00,
        transporte_importe: 0.00,

        casco: false,
        alforjas: false,
        pedales_automaticos: false,
        gps: false,

        
        kit_pinchazos: false,
        botellin: false,
        candado: false,
        seguro: false,
        bolsa_delantera: false,
        soporte_movil: false,
        credencial: false,

        pedales_automaticos_importe: '0.00',
        seguro_importe: '0.00',
        bolsa_delantera_importe: '0.00',
        soporte_movil_importe: '0.00',
        credencial_importe: '0.00',

        observacion_presupuesto: null,

        sin_iva: false,
        descuento_agencia: false,

        observaciones: null,
        factura: null,
        estado: {
          id: null,
          nombre: null,
        },
        cliente: {
          id: null,
          nombre: null,
          dni: null,
          domicilio: null,
          telefono: null,
          email: null,
          observaciones: null,
        },
        bicis: [],
      };
    },
  },
};
</script>
